import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { TextLocaValueProportional } from "../text/TextLocaValueProportional";
export var ResourceRequirement = function (_a) {
    var available = _a.available, required = _a.required, stylePositive = _a.stylePositive, styleNegative = _a.styleNegative;
    var className = Long.fromValue(available).greaterThanOrEqual(required)
        ? stylePositive || IdStyles.TextPositive
        : styleNegative || IdStyles.TextNegative;
    return (React.createElement("div", { className: "resource-requirement" },
        React.createElement(TextLocaValueProportional, { className: className, available: available, required: required })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/resource-requirement/ResourceRequirement.tsx
// module id = 364
// module chunks = 3